import React, { FunctionComponent } from 'react';

import { YES_NO_OPTIONS } from 'scenes/common/flows/types';
import { SingleFieldStepProps } from 'scenes/common/types';
import SingleSegmentedControlStep from 'scenes/common/components/Steps/SingleSegmentedControlStep';

const SingleYesNoStep: FunctionComponent<SingleFieldStepProps<string>> = ({
  onNext,
  question,
  helpText,
  stateKey,
  defaultStateValue,
  helpLink,
  onClickSaveQuoteModal,
}) => (
  <SingleSegmentedControlStep
    onNext={onNext}
    question={question}
    helpText={helpText}
    stateKey={stateKey}
    options={YES_NO_OPTIONS}
    defaultStateValue={defaultStateValue}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(helpLink && { helpLink })}
    onClickSaveQuoteModal={onClickSaveQuoteModal}
  />
);

export default SingleYesNoStep;
